/* eslint-disable */
import store from "../../store/index";
import axios from "axios";
import customModal from "../customModal/customModal.vue";
import viewAlertQueryPopup from '../ViewAlertQuery/viewAlertQueryPopup.vue';
import RaiseQueryPopup from "../RaiseQuerypopup/RaiseQueryPopup.vue";

export default {
    name: "ListSdvQueryModal",
    props: {
        signalid: {
            type: String,
            default: "",
        },
        
    },
    components: {
        customModal,
        viewAlertQueryPopup,
        RaiseQueryPopup
      },
    data() {
        return {
            idToken: "",
            headerValues: "",
            baseapi: process.env.VUE_APP_Service_URL,
            
            loadingBlock: false,
            // roles + recipients
            roleList: [],
            selectedRole: "",     
            recipients: [],      
            values: {
                Recipient: ""      
            },
            showQueryAlertPopup: false,
            queryid: "",
            showContent: true,
            Querydetails: "",
            showloader: false,
            showRaiseQuery: false,
            // errors
            errors: [],
                };
    },
    async mounted() {
        console.log("AssignSdvModal mounted with signalid:", this.signalid);
        this.idToken = store.getters.getIdToken;
        this.headerValues = {
            headers: {
                Authorization: "Bearer " + this.idToken,
                "Content-Type": "application/json",
            },
        };
        await this.openqueryapi(this.signalid);
    },
    methods: {
        viewforms(id) {
            console.log("queryid......", id);
            this.showQueryAlertPopup = true;
            this.queryid = id;
        },
        closedoption() {
            this.showQueryAlertPopup = false;
        },
       
        async openqueryapi(id) {
            this.Querydetails = [];
            this.showloader = true;
            try {
                const token = store.getters.getIdToken;
                const response = await axios.get(
                    `${this.baseapi}/forms/query/querylist?StudyId=${store.getters.getStudyIs}&QueryFor_Id=${id}&QueryFor=SDV&SortProperty=QueryOpenStatus&SortOrder=1`,
                    { headers: { Authorization: "Bearer " + token } }
                );
                this.Querydetails = Array.isArray(response.data.results) ? response.data.results : [];
                if (this.Querydetails.length === 0) {
                    this.showContent = false;
                }
                else if (this.Querydetails.length > 0) {
                    this.showContent = true;
                }
                this.showloader = false;
                console.log("Query details:", this.Querydetails);
            } catch (error) {
                this.Querydetails = [];
                this.showContent = false;
                this.showloader = false;
                console.error("Error fetching query details:", error);

            }
        },
        closemodal() {
            this.$emit("closeModal");
        },
        gotoraiseQuary(queryType) {
            this.showRaiseQuery = true;
        },
         async closeQueryModal(){
            this.showRaiseQuery = false;
            this.openqueryapi(this.signalid);
        },
        closeSDVQueryModal() {
      this.$emit('closeModal');
    },
    },
};